export default "__VITE_ASSET__D_uuqT0S__"